export const notificationsListingRoutes = [
  {
    path: 'listing',
    name: 'notifications-listing',
    component: () =>
      import(/* webpackChunkName: "notifications-listing" */ './NotificationsListing.vue')
  }
];
